export default __webpack_public_path__ + "static/media/G_Grass.db50f7ab.jpeg";